import { createContentPropTypes } from '../../helpers/content';

const newTemplateContent = {
	title: 'Are you sure you want to go back?',
	textBody:
		'If you go back now, none of the payment details you’ve entered will be saved and your template won’t be created.',
	destructiveActionButtonText: 'Yes, go back',
	safeActionButtonText: 'No, continue creating template',
};

const editTemplateContent = {
	title: 'Are you sure you want to go back?',
	textBody:
		'If you go back now, none of the payment details you’ve changed will be saved and your template won’t be updated.',
	destructiveActionButtonText: 'Yes, go back',
	safeActionButtonText: 'No, continue editing template',
};
const importPaymentsContent = {
	title: 'Are you sure you want to cancel?',
	textBody: "If you cancel now, any payment entries you've imported won't be saved.",
	destructiveActionButtonText: 'Yes, cancel',
	safeActionButtonText: 'No, go back',
};
const overwriteTemplateContent = {
	title: 'Another user has updated this template',
	textBody:
		'While you were making your changes, this template was updated by [[user]]. The most up-to-date version of the template was saved at [[datetime]] ',
	destructiveActionButtonText: "Overwrite [[user]]'s changes",
	safeActionButtonText: 'Cancel your changes',
};

const deleteIFTPaymentContent = {
	title: 'Are you sure you want to remove this payment?',
	textBody: 'If you remove this payment, all the details you’ve entered will be lost.',
	destructiveActionButtonText: 'Yes, remove payment',
	safeActionButtonText: 'No, go back',
};

const importPayeesContent = {
	title: 'Are you sure you want to cancel?',
	textBody: 'If you cancel now, any payee entries you’ve imported won’t be added.',
	destructiveActionButtonText: 'Yes, cancel',
	safeActionButtonText: 'No, go back',
};

export default {
	newTemplateContent,
	editTemplateContent,
	overwriteTemplateContent,
	deleteIFTPaymentContent,
	importPayeesContent,
	importPaymentsContent,
};
export const contentPropTypes = createContentPropTypes(newTemplateContent);
